import { DesignUploadMode } from 'swag-common/interfaces';
export default function isBox(product) {
  return Boolean((product === null || product === void 0 ? void 0 : product.designUploadMode) === DesignUploadMode.box);
}